import { Link } from 'react-router-dom';

const KANIT = { fontFamily: "'Kanit', system-ui, sans-serif" };

export const PanthersBanner = () => (
  <Link to="/panthers-partnership" className="block group" data-testid="panthers-banner" aria-label="KGOB is a Carolina Panthers Small Business Partner for 2026. About the partnership.">
    {/* Desktop (>= lg): strip with angled seam panel */}
    <div className="hidden lg:flex bg-white border-b border-[#EAEFF4] min-h-[200px]" data-testid="panthers-banner-desktop">
      <div className="flex flex-1 items-center gap-9 px-11 min-w-0 py-6">
        <img
          src="/brand/kgob-logo-light.svg"
          alt="Kohari Gonzalez Oneyear & Brown CPAs & Advisors"
          className="h-[46px] w-auto object-contain flex-shrink-0"
        />
        <span className="w-px self-stretch bg-[#E4E9EF]" aria-hidden="true" />
        <div className="flex flex-col gap-[7px] min-w-0" style={KANIT}>
          <span className="text-[12px] font-semibold tracking-[2.5px] text-[#0085CA]">OFFICIAL ANNOUNCEMENT</span>
          <span className="text-[23px] xl:text-[27px] font-semibold leading-[1.15] text-[#002C6B]">
            We've teamed up with the Carolina Panthers
          </span>
          <span className="text-[14px] font-semibold text-[#0085CA] transition-colors group-hover:text-[#002C6B]">
            About the 2026 partnership →
          </span>
        </div>
      </div>
      <div
        className="relative w-[400px] xl:w-[490px] self-stretch flex-shrink-0 bg-[#101820]"
        style={{ clipPath: 'polygon(64px 0, 100% 0, 100% 100%, 0 100%)' }}
      >
        <div
          className="absolute inset-0 bg-[#0085CA] flex items-center pl-[56px] pr-5"
          style={{ clipPath: 'polygon(75px 0, 100% 0, 100% 100%, 11px 100%)' }}
        >
          <img
            src="/brand/panthers/panthers-sbp-blue-cropped.jpg"
            alt="Carolina Panthers Small Business Partner 2026"
            className="max-h-[148px] w-auto max-w-full object-contain"
          />
        </div>
      </div>
    </div>

    {/* Mobile / tablet (< lg): stacked */}
    <div className="lg:hidden bg-white" data-testid="panthers-banner-mobile">
      <div className="flex flex-col items-center text-center gap-2 pt-[26px] px-[22px] pb-6" style={KANIT}>
        <img
          src="/brand/kgob-logo-light.svg"
          alt="Kohari Gonzalez Oneyear & Brown CPAs & Advisors"
          className="h-[34px] w-auto object-contain mb-1.5"
        />
        <span className="text-[11px] font-semibold tracking-[2.2px] text-[#0085CA]">OFFICIAL ANNOUNCEMENT</span>
        <span className="text-[22px] font-semibold leading-[1.2] text-[#002C6B]">
          We've teamed up with the Carolina Panthers
        </span>
        <span className="text-[14px] font-semibold text-[#0085CA]">About the 2026 partnership →</span>
      </div>
      <div className="bg-[#101820]" style={{ clipPath: 'polygon(0 20px, 100% 0, 100% 100%, 0 100%)' }}>
        <div
          className="bg-[#0085CA] pt-12 pb-[26px] flex justify-center"
          style={{ clipPath: 'polygon(0 30px, 100% 9px, 100% 100%, 0 100%)' }}
        >
          <img
            src="/brand/panthers/panthers-sbp-blue-cropped.jpg"
            alt="Carolina Panthers Small Business Partner 2026"
            className="w-[80%] h-auto object-contain"
          />
        </div>
      </div>
    </div>
  </Link>
);
